import React from 'react'
import { Button, Jumbotron } from 'react-bootstrap'

export const AddUpdateProductsView = (props) => {
    return <div>

        <Jumbotron>Paste the delisting data in the box and click Submit</Jumbotron>
        <div className='mt-3'><textarea value={props.data} onChange={props.onChangeUpdate}></textarea></div>
        <div><Button onClick={props.onClickSubmit}>Submit</Button></div>
    </div>
}